import React, { useEffect } from "react";
import { Grid } from "@mui/material";
import FormField from "layouts/pages/account/components/FormField";
import SettingsCard from "./SettingsCard";

const FooterContentSection = ({ inputData, elements, autoSaveField, autoSaveElement }) => {
  useEffect(() => {
    if (typeof autoSaveField === "function" && inputData?.footer_layout === "modern") {
      autoSaveField("footer_layout", "classic");
    }
  }, [autoSaveField]);

  const save = (e) => {
    if (autoSaveField) autoSaveField(e.target.name, e.target.value);
  };
  const saveElement = (e) => {
    if (autoSaveElement) autoSaveElement(e.target.name, e.target.value);
  };

  return (
    <SettingsCard
      title="Footer Content"
      subtitle="Configure footer information"
      gridProps={{
        xs: 12,
        sx: {
          "@media (min-width: 1100px)": {
            flexBasis: "calc(50% - 12px)",
            maxWidth: "calc(50% - 12px)",
            width: "calc(50% - 12px)"
          }
        }
      }}
    >
      <Grid container spacing={2.5}>
        {/* Footer layout dropdown hidden — always classic (see useEffect above) */}
        {/*
        <Grid item xs={12}>
          <SoftTypography
            component="label"
            variant="caption"
            fontWeight="bold"
            display="block"
            mb={1}
          >
            Footer layout
          </SoftTypography>
          <select
            name="footer_layout"
            defaultValue={footerLayout}
            onChange={save}
            style={{
              width: "100%",
              maxWidth: 520,
              padding: "10px 12px",
              borderRadius: "8px",
              border: "1px solid #d2d6da",
              fontSize: "14px",
              backgroundColor: "#fff",
            }}
          >
            <option value="classic">Classic — current design</option>
            <option value="modern">Multi-column — contact, social icons, site links</option>
          </select>
          <SoftTypography variant="caption" sx={{ display: "block", mt: 1, color: "#666", fontSize: "11px" }}>
            Classic is unchanged. Multi-column uses flat-style icons and clickable navigation from your footer menu.
          </SoftTypography>
        </Grid>
        */}
        <Grid item xs={12}>
          <FormField
            label="Address"
            name="address"
            defaultValue={inputData?.address || "123 Main St., Anytown, USA"}
            onBlur={save}
          />
        </Grid>
        <Grid item xs={12}>
          <FormField
            label="Copyright"
            name="copyright"
            defaultValue={inputData?.copyright || "© 2025"}
            onBlur={save}
          />
        </Grid>
        <Grid item xs={12}>
          <FormField
            key={`footer_phone-${elements?.footer_phone ?? ""}`}
            label="Footer Phone headline"
            name="footer_phone"
            placeholder="Phone"
            defaultValue={elements?.footer_phone ?? ""}
            onBlur={saveElement}
          />
        </Grid>
        <Grid item xs={12}>
          <FormField
            key={`footer_email-${elements?.footer_email ?? ""}`}
            label="Footer Email headline"
            name="footer_email"
            placeholder="Email"
            defaultValue={elements?.footer_email ?? ""}
            onBlur={saveElement}
          />
        </Grid>
        <Grid item xs={12}>
          <FormField
            key={`footer_address-${elements?.footer_address ?? ""}`}
            label="Footer Address headline"
            name="footer_address"
            placeholder="Address"
            defaultValue={elements?.footer_address ?? ""}
            onBlur={saveElement}
          />
        </Grid>
        <Grid item xs={12}>
          <FormField
            key={`footer_follow_us-${elements?.footer_follow_us ?? ""}`}
            label="Footer Follow Us on Social Media headline"
            name="footer_follow_us"
            placeholder="Follow Us on Social Media"
            defaultValue={elements?.footer_follow_us ?? ""}
            onBlur={saveElement}
          />
        </Grid>
      </Grid>
    </SettingsCard>
  );
};

export default FooterContentSection;
